export const SET_LOADING = 'SET_LOADING'
export const SET_SUPPLIERS = 'SET_SUPPLIERS'
export const SET_PRODUCTS = 'SET_PRODUCTS'
export const SET_SUPPLY_DETAIL = 'SET_SUPPLY_DETAIL'
export const SET_SUPPLY_STATUSES = 'SET_SUPPLY_STATUSES'
